import { useEffect, useState } from "react";
import visionCallService from "../services/visionCallService";
import { visionURL } from "../config/environment";

export const useFetch = (apiUrl, changes, call = true) => {
  const [data, setData] = useState();

  useEffect(() => {
    const fetchData = async () =>
      setData(
        await visionCallService.requestWithNormalizer(
          apiUrl,
          res => console.log(res),
          err => console.error(err)
        )
      );
    if (call) {
      fetchData();
    }
  }, [apiUrl, call, changes]);
  return data;
};

export const useReportPath = apiUrl => {
  const report_response = useFetch(apiUrl);
  const report_path = report_response
    ? report_response["report_path"]
    : undefined;

  const report = () => {
    const reportUrl = `${visionURL}${report_path}`;
    var win = window.open(reportUrl, "_blank");
    win.focus();
  };
  return report_path ? report : report_path;
};
